import { Box, Flex, Grid, GridItem, Spinner, Text } from "@chakra-ui/react";
import ConciliationSidebar, { ProposalSidebarItem } from "../ConciliationSidebar";
import ConciliationDetails from "../ConciliationDetails";
import { ConfiguracaoConciliacao } from "@/models/conciliation-config.model";

interface ConciliationContentViewProps {
  proposals: ProposalSidebarItem[];
  selectedProposalId: string | null;
  setSelectedProposalId: React.Dispatch<React.SetStateAction<string | null>>;
  selectedProposalIds: string[];
  onToggleProposalSelection: (proposalId: string, checked: boolean) => void;
  onReconcileSelected: () => void;
  isReconcilingSelected: boolean;
  totalItems: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
  isLoading?: boolean;
  configuracoes: ConfiguracaoConciliacao[];
  onConciliationUpdated: () => Promise<void> | void;
}

export default function ConciliationContentView({
  proposals,
  selectedProposalId,
  setSelectedProposalId,
  selectedProposalIds,
  onToggleProposalSelection,
  onReconcileSelected,
  isReconcilingSelected,
  totalItems,
  currentPage,
  pageSize,
  onPageChange,
  isLoading,
  configuracoes,
  onConciliationUpdated,
}: ConciliationContentViewProps) {
  const selectedProposalIdValue = selectedProposalId ?? "";
  const hasProposals = proposals.length > 0;

  const handleSetSelectedProposalId: React.Dispatch<React.SetStateAction<string>> = (value) => {
    if (typeof value === "function") {
      setSelectedProposalId((previousValue) => {
        const normalizedPrevious = previousValue ?? "";
        return value(normalizedPrevious);
      });
      return;
    }

    setSelectedProposalId(value);
  };

  if (isLoading) {
    return (
      <Grid templateColumns="repeat(12, 1fr)" width="100%" gap={4} my={6}>
        <GridItem colSpan={12}>
          <Flex justifyContent="center" alignItems="center" py={10}>
            <Spinner size="sm" mr={2} />
            <Text fontSize="sm">Carregando propostas...</Text>
          </Flex>
        </GridItem>
      </Grid>
    );
  }

  if (!hasProposals) {
    return (
      <Grid templateColumns="repeat(12, 1fr)" width="100%" gap={4} my={6}>
        <GridItem colSpan={12}>
          <Box
            minH="220px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            bg="white"
          >
            <Text fontSize="lg" color="gray.600">
              Nenhuma proposta encontrada para os filtros aplicados.
            </Text>
          </Box>
        </GridItem>
      </Grid>
    );
  }

  return (
    <Grid templateColumns="repeat(12, 1fr)" width="100%" gap={4} my={6}>
      <GridItem colSpan={3}>
        <ConciliationSidebar
          proposals={proposals}
          selectedProposalId={selectedProposalIdValue}
          setSelectedProposalId={handleSetSelectedProposalId}
          selectedProposalIds={selectedProposalIds}
          onToggleProposalSelection={onToggleProposalSelection}
          onReconcileSelected={onReconcileSelected}
          isReconcilingSelected={isReconcilingSelected}
          totalItems={totalItems}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={onPageChange}
          isLoading={isLoading}
          configuracoes={configuracoes}
        />
      </GridItem>

      <GridItem colSpan={9}>
        <ConciliationDetails
          proposalId={selectedProposalIdValue}
          isShowSteps={true}
          configuracoes={configuracoes}
          onConciliationUpdated={onConciliationUpdated}
        />
      </GridItem>
    </Grid>
  );
}
